export default "__VITE_ASSET__3a3332a3__"